import BreadCrumbs from '@components/BreadCrumbs'
import BreadCrumbsProvider from '@components/BreadCrumbs/State/state'
import { CART_STATE_KEY } from '@components/cart/State/state'
import { IntegratedHeader } from '@components/common/Header/IntegratedHeader'
import { IntegratedHeaderPreloaded } from '@components/common/Header/IntegratedHeaderPreloaded'
import { Subscription } from '@components/common/Subscription'
import { CwsGrid, CwsGridCol, CwsGridRow, CwsSection, CwsAccessibility } from '@components/cws'
import { AppStateTypes } from '@context/reducer'
import { useAppState } from '@context/state'
import { useSso } from '@hooks/useSso'
import { nicerLog } from '@utils/console-utils'
import { localStorageHelper } from '@utils/localStorageHelper'
import { useRouter } from 'next/router'
import { FC, PropsWithChildren, useState } from 'react'
import { useEffect } from 'react'
import FooterComponent from '../Footer/Footer'
import clsx from 'clsx'
import s from './Layout.module.scss'
import { isPrintMode } from '@utils/is-print-mode'

export const Layout: FC<PropsWithChildren> = (props) => {
  const { children } = props
  const { events, pathname, locale } = useRouter()
  const [isClient, setIsClient] = useState(false)
  useSso()

  useEffect(() => {
    setIsClient(true)
  }, [])

  const {
    dispatch,
    state: { topOffset, productsListId },
  } = useAppState()

  const {
    state: { customer },
  } = useAppState()

  useEffect(() => {
    if (pathname === '/cart') return
    localStorageHelper.remove(CART_STATE_KEY)
  }, [])

  /* TODO is mobile */

  const { newsletter = '0' } = customer ?? { newsletter: '0' }

  const isIndexPage = pathname === '/'
  const visibleHeaderAndFooter = !pathname.endsWith('/wishlist-print')
  const isPrint = isPrintMode()
  return (
    <>
      <CwsAccessibility locale={locale} skipHref="#main-content" />
      <CwsSection backgroundColor="white">
        <BreadCrumbsProvider>
          {!isClient && <IntegratedHeaderPreloaded />}
          {isClient && visibleHeaderAndFooter && <IntegratedHeader />}
          <main className={clsx(s.layoutContent)} id="main-content">
            <CwsGrid width={isPrint && 'fluid'}>
              <CwsGridRow noGutter>
                {!isIndexPage && visibleHeaderAndFooter && <BreadCrumbs />}
                <CwsGridCol col="12">{children}</CwsGridCol>
                {visibleHeaderAndFooter && (
                  <CwsGridCol>
                    <Subscription />
                  </CwsGridCol>
                )}
              </CwsGridRow>
            </CwsGrid>
          </main>
        </BreadCrumbsProvider>
        {visibleHeaderAndFooter && <FooterComponent />}
      </CwsSection>
    </>
  )
}

export default Layout
